import { z } from "zod";

export const commaSeparatedList = <T extends z.ZodType>(schema: T) =>
  z.preprocess((value) => {
    if (value == null || value === "") return undefined;
    if (Array.isArray(value)) {
      return value
        .filter((item): item is string => typeof item === "string")
        .map((item) => item.trim())
        .filter(Boolean);
    }
    if (typeof value !== "string") return value;

    return value
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  }, z.array(schema).optional());
